/**
 * Maps the IDs of the items in the array.
 *
 * @param {Array} items - The array of items to map.
 * @returns {Array} - The array of IDs.
 */
export const mapIds = (items) => items?.map((item) => item.id || item) || [];